import React, { useEffect, useState } from 'react';
import Dropdown from '../Dropdown/Dropdown'; // Import Dropdown component
import moment from 'moment-timezone';
import styles from './Chart.module.css';
import { Row, Container, Col } from "reactstrap";
import { FaInfoCircle } from "react-icons/fa";
import SwingHighLowInfo from "./Info/SwingHighLowInfo"
import { useAppContext } from "../../App"; // Import AppContext

function SwingHighLowChart() {

  const {
    currencyPair, setCurrencyPair, timeInterval, setTimeInterval, timeZone, setTimeZone,timeZones,g50Currencies,timeIntervals, Plot, LoadingSpinner
  } = useAppContext(); // Destructure values from AppContext

  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isInfoOpen, setIsInfoOpen] = useState(false); // Manage FvgInfo state
  const toggleInfoDrawer = () => {
    setIsInfoOpen((prev) => !prev); // Toggle FvgInfo drawer
  };

  useEffect(() => {
    const fetchChartData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch('https://vidplay-api.deng-software.com/flask/swingHL', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ currencyPair, timeInterval, timeZone }),
        });

        if (!response.ok) {
          throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();

        // Adjust x-axis date/time to the selected time zone
        if (data?.data) {
          data.data.forEach((trace) => {
            if (trace.x) {
              trace.x = trace.x.map((datetime) =>
                moment.tz(datetime, 'UTC').tz(timeZone).format('YYYY-MM-DD HH:mm:ss')
              );
            }

            // Apply styling for Swing Highs and Swing Lows
            if (trace.name === 'Swing Highs') {
              trace.marker = {
                color: 'blue',
                size: 8,
                symbol: 'triangle-up',
              };
            }
            if (trace.name === 'Swing Lows') {
              trace.marker = {
                color: 'orange',
                size: 8,
                symbol: 'triangle-down',
              };
            }

            // Ensure hovertext is used for hover info
            if (trace.hovertext) {
              trace.hoverinfo = 'text';
            }
          });
        }

        setChartData(data);
      } catch (err) {
        setError(`Failed to fetch chart data: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, [currencyPair, timeInterval, timeZone]);

  const handleCurrencyPairChange = (value) => {
    setCurrencyPair(value); // Update global state
  };

  const handleTimeIntervalChange = (value) => {
    setTimeInterval(value); // Update global state
  };

  const handleTimeZoneChange = (value) => {
    setTimeZone(value); // Update global state
  };

  if (loading) {
    return <LoadingSpinner message="Loading chart data..." />;
  }

  if (error) {
    return <p className={styles.error}>{error}</p>;
  }

  return (
    <Container><Row>
      <div className={styles.chartContainer}>
        {/* Header with Info Icon */}
        <div className={styles.header}>
          <h2 className={styles.chartTitle}>
            Swing High/Low Analysis
            <FaInfoCircle
              onClick={toggleInfoDrawer}
              style={{
                marginLeft: "20px",
                cursor: "pointer",
                fontSize: "20px",
                verticalAlign: "middle",
              }}
              title="Open Liquidity Sweep  Info" // Tooltip for accessibility
            />
          </h2>
        </div>
        <SwingHighLowInfo isOpen={isInfoOpen} toggleDrawer={toggleInfoDrawer} />
        <Row>
          {/* Dropdowns */}
          <Col xs={6} md={3}>
            <Dropdown
              label="Currency Pair"
              options={g50Currencies.map((currency) => ({
                label: `${currency.country} (${currency.pair})`,
                value: currency.pair,
              }))}
              value={currencyPair}
              onChange={handleCurrencyPairChange}
            />
          </Col>
          <Col xs={6} md={3}>
            <Dropdown
              label="Time Interval"
              options={timeIntervals}
              value={timeInterval}
              onChange={handleTimeIntervalChange}
            /></Col>
          <Col md={3}>
            <Dropdown
              label="Time Zone"
              options={timeZones.map((zone) => ({
                label: zone.label,
                value: zone.value,
              }))}
              value={timeZone}
              onChange={handleTimeZoneChange}
            /></Col>
          <Col md={3}>

          </Col>
        </Row>
        {/* Plotly Chart */}
        <Plot
          data={chartData.data}
          layout={{
            ...chartData.layout,
            hovermode: 'closest', // Highlight the nearest data point on hover
            autosize: true,
            margin: { l: 40, r: 40, t: 40, b: 40 },
            xaxis: { title: 'Time', showgrid: true, automargin: true },
            yaxis: { title: 'Price', showgrid: true, automargin: true },
            legend: { orientation: 'h', x: 0, y: 10 }, // Horizontal legend below chart

          }}
          style={{ width: '100%', height: "70vh" }}
          config={{
            responsive: true, // Make the chart responsive
            scrollZoom: true,
          }}
        /></div>
    </Row></Container>
  );
}

export default SwingHighLowChart;
